import { z } from "zod";
const computedFieldDefinitionIdSchema = z.uuid().brand();
function asComputedFieldDefinitionId(id) {
  return computedFieldDefinitionIdSchema.parse(id);
}
const ComputedFieldResourceType = {
  CONTACT: "contact",
  /** Customer interaction (grading) custom fields. */
  GRADING: "grading"
};
const allComputedFieldResourceTypes = [
  ComputedFieldResourceType.CONTACT,
  ComputedFieldResourceType.GRADING
];
const computedFieldResourceTypeSchema = z.enum(
  allComputedFieldResourceTypes
);
const computedFieldResourceTypeLabels = {
  [ComputedFieldResourceType.CONTACT]: "Contact",
  [ComputedFieldResourceType.GRADING]: "Customer interaction"
};
const computedFieldComputationSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("count_in"),
    source_custom_field_definition_id: z.uuid(),
    values: z.array(z.string().min(1)).min(1, "At least one value is required")
  }).strict(),
  z.object({
    type: z.literal("rate_in"),
    source_custom_field_definition_id: z.uuid(),
    numerator_values: z.array(z.string().min(1)),
    denominator_values: z.array(z.string().min(1)).min(1, "Denominator must include at least one value")
  }).strict()
]);
const computedFieldComputationTypeLabels = {
  count_in: "Count",
  rate_in: "Rate"
};
const computedFieldDefinitionWritablePayloadSchema = z.object({
  display_name: z.string().trim().min(1),
  resource_type: computedFieldResourceTypeSchema,
  computation: computedFieldComputationSchema
});
function getComputedFieldSourceCustomFieldDefinitionId(computation) {
  return computation.source_custom_field_definition_id;
}
export {
  ComputedFieldResourceType,
  asComputedFieldDefinitionId,
  computedFieldComputationSchema,
  computedFieldComputationTypeLabels,
  computedFieldDefinitionIdSchema,
  computedFieldDefinitionWritablePayloadSchema,
  computedFieldResourceTypeLabels,
  computedFieldResourceTypeSchema,
  getComputedFieldSourceCustomFieldDefinitionId
};
//# sourceMappingURL=computedField.js.map
